import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';

const faqs = [
  {
    q: "Is it really a one-time payment?",
    a: "Yes. You pay once and the QR code is yours forever. No monthly fees, no hidden costs."
  },
  {
    q: "Can I change the destination URL later?",
    a: "Absolutely. That's the whole point of a dynamic QR code. You can log into your dashboard and update the URL as many times as you want."
  },
  {
    q: "Do the QR codes ever expire?",
    a: "No. As long as our service is running (and we plan to run it forever), your QR codes will continue to work and redirect to your chosen URL."
  },
  {
    q: "Is there a limit on how many times it can be scanned?",
    a: "Nope! Scan it 10 times or 10 million times, we don't care. Unlimited scans are included."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="w-full py-24 px-6 bg-white">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-12 text-center">
          FAQS
        </h2>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="border-4 border-black bg-white"
            >
              <button 
                className="w-full flex justify-between items-center p-6 text-left font-black text-xl hover:bg-[#f0f0f0] transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span>{faq.q}</span>
                <span className="p-1 border-2 border-black bg-black text-white">
                  <SafeIcon icon={openIndex === index ? FiMinus : FiPlus} className="w-5 h-5" />
                </span>
              </button>
              
              {openIndex === index && (
                <div className="p-6 pt-0 font-medium text-lg leading-relaxed border-t-4 border-black bg-[#fafafa]">
                  <div className="pt-6">{faq.a}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;